/**
 * Klucz dostępu - do identyfikacji klienta - wysyłamy jawnie w żądaniu
 */
export const ACCEES_KEY = 'M07Z7DRYI57ITM66'
/**
 * Klucz sekretny - do podpisu żądania klienta - nigdy nie wysyłany przez sieć
 */
export const SECRET_KEY = 'dMyBdHMl2daMRGXVuMma5py+nJRoPwHz0CDToZb+tNM='

/**
 * Znak nowej lini
 */
export const SEPARATOR_NEW_LINE = '\n'

/**
 * Separator średnik
 */
export const SEPARATOR_SEMICOLON = ';'

/**
 * Separator dwukropek
 */
export const SEPARATOR_COLON = ':'

/**
 * Separator ukośnik
 */
export const SEPARATOR_SLASH = '/'

/**
 *  Część autoryzacji hmac - identyfikator klienta
 */
export const SIGN_PART_CREDENTIAL = "Credential";

/**
 * Część autoryzacji hmac - kolekcja nagłówków biorących udział w podpisie, przedzielonych średnikiem
 */
export const SIGN_PART_SIGNED_HEADERS = "SignedHeaders";

/**
 * Część autoryzacji hmac - podpis
 */
export const SIGN_PART_SIGNATURE = "Signature";

/**
 * Nagłówki biorące udział w podpisywaniu żądania
 */
export const SIGNED_HEADERS = {
    X_FLOW_DATE: 'X-Flow-Date',
    X_FLOW_RID: 'X-Flow-RID'
}